import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Table, Button, Spinner, Alert } from 'react-bootstrap';
import api from '../api/axios';

const ExamHistory = () => {
  const navigate = useNavigate();
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await api.get('/user-exams.php');
        setExams(res.data);
      } catch (err) {
        setError('Failed to load exam history');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, []);

  if (loading) return <Container className="mt-5 text-center"><Spinner animation="border" /></Container>;
  if (error) return <Container className="mt-5"><Alert variant="danger">{error}</Alert></Container>;

  return (
    <Container className="mt-4">
      <h2>My Exam History</h2>
      <Button variant="outline-primary" className="mb-3" onClick={() => navigate('/dashboard')}>
        Back to Dashboard
      </Button>
      {exams.length === 0 && <Alert variant="info">No exams taken yet.</Alert>}
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Date</th>
            <th>Group</th>
            <th>Score</th>
            <th>Percentage</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {exams.map(e => (
            <tr key={e.id}>
              <td>{new Date(e.started_at).toLocaleString()}</td>
              <td>{e.group_name || 'All'}</td>
              <td>{e.completed ? `${e.score} / ${e.max_score}` : 'Incomplete'}</td>
              <td>{e.completed ? `${e.percentage}%` : '—'}</td>
              <td>
                {e.completed && (
                  <Button size="sm" variant="info" onClick={() => navigate(`/exam/report/${e.id}`)}>
                    View Report
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default ExamHistory;